module.exports = __webpack_public_path__ + "img/approved-icon.f8a355ce.svg";